/**
 * Header iconography for the inventory detail flyout. Also plugged into
 * SectionIconography as the 'Inventory' entry; kept as a standalone export
 * since InventoryFlyoutHost references it directly for the breadcrumb.
 */
export type InventoryHeaderConfigShape = {
  icon: string;
  backgroundColor: string;
  color: string;
  singular: string;
  plural: string;
};

export const InventoryHeaderConfig: InventoryHeaderConfigShape = {
  icon: 'pi pi-map-marker',
  backgroundColor: '#E0F2FE',
  color: '#0284C7',
  singular: 'Inventory',
  plural: 'Inventory',
};
